export const DEFAULT_THEME = {
  sidebarBg: '#304156',
  sidebarSubBg: '#1f2d3d',
  sidebarHoverBg: '#001528',
  sidebarText: '#bfcbd9',
  sidebarActive: '#409eff',
  headerBg: '#ffffff',
  headerBorder: '#e9e9e9',
  headerText: '#303133',
}

export const PRESET_THEMES = {
  default: {
    label: '默认蓝',
    theme: { ...DEFAULT_THEME },
  },
  dark: {
    label: '深色侧栏',
    theme: {
      sidebarBg: '#1d1e1f',
      sidebarSubBg: '#141414',
      sidebarHoverBg: '#0d0d0d',
      sidebarText: '#cfd3dc',
      sidebarActive: '#409eff',
      headerBg: '#ffffff',
      headerBorder: '#e4e7ed',
      headerText: '#303133',
    },
  },
  green: {
    label: '清新绿',
    theme: {
      sidebarBg: '#2f4050',
      sidebarSubBg: '#243442',
      sidebarHoverBg: '#1a2832',
      sidebarText: '#bfcbd9',
      sidebarActive: '#67c23a',
      headerBg: '#ffffff',
      headerBorder: '#e4e7ed',
      headerText: '#303133',
    },
  },
}

export const THEME_STORAGE_KEY = 'laundry_theme'
